module.exports = __webpack_public_path__ + "img/diamond-fill.f2eb6390.svg";